import { render, staticRenderFns } from "./ModalEditSerialnumber.vue?vue&type=template&id=8506df5a&"
import script from "./ModalEditSerialnumber.vue?vue&type=script&lang=js&"
export * from "./ModalEditSerialnumber.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditSerialnumber.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports